import * as styles from "./DrawerTitle.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Drawer as BaseDrawer } from "@base-ui/react/drawer";

import type { DrawerTitleProps } from "./Drawer.types";

export function DrawerTitle({
  className,
  ...props
}: DrawerTitleProps): JSX.Element {
  return (
    <BaseDrawer.Title
      data-slot="drawer-title"
      className={clsx(styles.title, className)}
      {...props}
    />
  );
}
